import gql from 'graphql-tag';

export const add = gql`mutation CreateCargo($cargo: CargoInput!) {
    createCargo(cargo: $cargo) {
        id
        quantity
        perTonUsd
        value
        outturnTonnes
        customerReference
        receiver
        blDate
        blNumber
        certificateReference
        supplier
        stowage
        excessExclusion
        commodity{
            id
            name
            riskFactor
            isArchived
            commodityGroup {
                id
                name
            }
        }

        cargoPorts {
            id
            cargo {
                id
            }
            port {
                id
            }
            operation
            estimatedTimeOfArrival
            isConfirmed
        }

        clientRate {
            id
            name
            creationDate
            client {
                id
            }
            isMarineOnly
            rate
            franchise
        }
        underwriterRate {
            id
            name
            rate
            company {
                id
                name
            }
        }
    }
}`;


export const edit = gql`mutation EditCargo($id: ID!, $cargo: CargoInput!) {
    editCargo(id: $id, cargo: $cargo) {
        id
        quantity
        perTonUsd
        value
        outturnTonnes
        customerReference
        receiver
        blDate
        blNumber
        certificateReference
        supplier
        stowage
        excessExclusion
        commodity{
            id
            name
            riskFactor
            isArchived
            commodityGroup {
                id
                name
            }
        }

        cargoPorts {
            id
            cargo {
                id
            }
            port {
                id
            }
            operation
            estimatedTimeOfArrival
            isConfirmed
        }

        clientRate {
            id
            name
            creationDate
            client {
                id
            }
            isMarineOnly
            rate
            franchise
        }
        underwriterRate {
            id
            name
            rate
            company {
                id
                name
            }
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/cargo.js